import { useMemo, useDebugValue } from "react";
import { useCalculation } from "../context";
import { getInNamespaced } from "../../calculator/utils";
export function useVariableData(namespace, variableName) {
    const [data] = useVariablesData(namespace && variableName
        ? {
            namespace,
            variableName
        }
        : undefined);
    useDebugValue(data);
    const { value, missing, writeLocked } = data || {};
    const variableData = useMemo(() => ({ value, missing, writeLocked, variableName, namespace }), [value, missing, writeLocked, variableName, namespace]);
    return variableData;
}
export function useVariablesData(...variables) {
    const { values, isMissing, isWriteLocked } = useCalculation("values", "isMissing", "isWriteLocked");
    const data = variables.map(v => {
        if (v == null)
            return undefined;
        const { namespace, variableName } = v;
        const value = getInNamespaced(values, namespace, variableName);
        const missing = getInNamespaced(isMissing, namespace, variableName);
        const writeLocked = getInNamespaced(isWriteLocked, namespace, variableName);
        return {
            value,
            missing,
            writeLocked,
            variableName,
            namespace
        };
    });
    return data;
}
//# sourceMappingURL=useVariableData.js.map